import React, { memo } from "react"

const Table = memo(({ content, book, id }) => {
  const styles = {
    paragraph: {
      margin: "5px 0",
    },
    2: {
      color: "red",
    },
    3: {
      color: "green",
    },
    4: {
      color: "blue",
    },
  }
  return (
    <div style={styles.paragraph}>
      <table>
        <tbody>
          {content.map((row, rIndex) => {
            return (
              <tr key={`${id}-row-${rIndex}`}>
                {row.children.map((cell, cIndex) => {
                  if (rIndex === 0) {
                    return (
                      <th
                        key={`${id}-row-${rIndex}-cell-${cIndex}`}
                        style={book === "Mat" ? styles[cIndex] : {}}
                      >
                        {cell.text}
                      </th>
                    )
                  }
                  return (
                    <td
                      key={`${id}-row-${rIndex}-cell-${cIndex}`}
                      style={book === "Mat" ? styles[cIndex] : {}}
                    >
                      {cell.text}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
})

export default Table
